import { createBrowserRouter, Navigate, useLocation } from "react-router-dom";
import { PrivateRoute } from "./PrivateRoute";
import { LoginScreen } from "../components/auth/LoginScreen";
import { PublicRoute } from "./PublicRoute";
import PublicLayout from "./../layouts/PublicLayout";
import React, { useEffect } from "react";
import { ErrorPage } from "../errors";
import { componentes_routes } from "./routes";
import { AppLayout } from "../layouts/app";

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    }); // Scroll to the top when the location changes
  }, [pathname]);

  return null; // This component doesn't render anything
};
const PageWrapper = ({ children }) => {
  return (
    <>
      <ScrollToTop />
      {children}
    </>
  );
};
export const createRouter = (dynamicRoutes = []) => {
  const privateChildren = dynamicRoutes
    .map((route) => {
      const ExistComponent = componentes_routes?.find(
        (x) => x.key === route.componente
      );

      if (!ExistComponent) return null;

      const path = route.path.startsWith("/")
        ? route.path.slice(1)
        : route.path;

      return {
        path,
        element: React.createElement(ExistComponent.Componente),
      };
    })
    .filter(Boolean);
  const routes = [
    {
      element: <PublicLayout />,
      children: [
        {
          path: "/login",
          element: (
            <PublicRoute>
              <LoginScreen />
            </PublicRoute>
          ),
        },
      ],
    },
  ];

  // Solo agregamos la ruta privada si hay al menos un objeto válido
  if (Array.isArray(privateChildren) && privateChildren.length > 0) {
    routes.push({
      path: "/",
      element: <PageWrapper children={<AppLayout />} />,
      errorElement: <ErrorPage />,
      children: [
        {
          element: <PrivateRoute />,
          children: [...privateChildren],
        },
      ],
    });
    // Ruta catch-all que redirige al primer módulo privado
    routes.push({
      path: "*",
      element: <Navigate to={`/${privateChildren[0].path}`} replace />,
    });
  } else {
    // Si no hay rutas privadas, redirige al login
    routes.push({
      path: "*",
      element: <Navigate to="/login" replace />,
    });
  }

  return createBrowserRouter(routes, {
    future: {
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_relativeSplatPath: true,
      v7_skipActionErrorRevalidation: true,
      v7_startTransition: true,
    },
  });
};
